import { Alert, Box, Button, Card, Divider, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography, Zoom } from '@mui/material'
import { useEffect, useState } from 'react'
import axios from 'axios';
import { ports } from 'src/config';
import { useSnackbar } from 'notistack';
import useLayoutContext from 'src/hooks/useAuthLayout';

export default function Index() {
    const { drawerOpen } = useLayoutContext()
    const { enqueueSnackbar } = useSnackbar();
    const [titular, setTitular] = useState('T')
    const [tipodocumento, setTipodocumento] = useState('01')
    const [documento, setDocumento] = useState('')
    const [paterno, setPaterno] = useState('')
    const [materno, setMaterno] = useState('')
    const [nombres, setNombres] = useState('')
    const [direccion, setDireccion] = useState('')
    const [estadoCivil, setEtadoCivil] = useState('')
    const [sexo, setSexo] = useState('')
    const [nacimiento, setNacimiento] = useState('')
    const [tipodocumentoTitular, setTipodocumentoTitular] = useState('01')
    const [documentoTitular, setDocumentoTitular] = useState('')
    const [paternoTitular, setPaternoTitular] = useState('')
    const [maternoTitular, setMaternoTitular] = useState('')
    const [nombresTitular, setNombresTitular] = useState('')
    const [celular, setCelular] = useState('')
    const [correo, setCorreo] = useState('')

    const [estadoCivilArray, setEstadoCivilArray] = useState([])

    const getDatos = async () => {
        try {
            const response = await axios.get(`https://apis.vesaliohce.com.pe/admision/estadoCivil`)

            if (response.status === 200) {
                setEstadoCivilArray(response.data)
            } else {
                setEstadoCivilArray([])
            }
        } catch (e) {
            setEstadoCivilArray([])
        }
    }
    useEffect(() => {
        getDatos()
    }, [])

    useEffect(() => {
        console.log(drawerOpen.item)
        if (drawerOpen.item.sistcomp !== null) {
            let sistcomp = drawerOpen.item.sistcomp
            setTitular(sistcomp.Tip_RelaConTit)
            setTipodocumento(sistcomp.Cod_TipIdenti)
            setDocumento(sistcomp.Nro_DocIdenti)
            setPaterno(sistcomp.Des_ApePaterno)
            setMaterno(sistcomp.Des_ApeMaterno)
            setNombres(sistcomp.Des_Nombres)
            setDireccion(sistcomp.Des_DirDomicilio)
            setEtadoCivil(sistcomp.Cod_EstaCivil)
            setNacimiento(sistcomp.Fec_Nacimien.split('T')[0])
            setSexo(sistcomp.Des_Sexo)
            setPaternoTitular(sistcomp.Des_ApePatTit)
            setMaternoTitular(sistcomp.Des_ApeMatTit)
            setNombresTitular(sistcomp.Des_NombresTit)
            setCelular(sistcomp.Nro_TelMovil)
            setCorreo(sistcomp.Des_CorreoElec)
        }
    }, [drawerOpen])

    const tipos = [
        { id: '01', name: 'D.N.I.' },
        { id: '02', name: 'Carné de extranjeria' },
        { id: '03', name: 'Pasaporte' },
    ]
    const genero = [
        { id: 'M', name: 'Masculino' },
        { id: 'F', name: 'Femenino' },
    ]
    const relacion = [
        { id: 'T', name: 'Titular' },
        { id: 'P', name: 'Padre' },
        { id: 'M', name: 'Madre' },
        { id: 'H', name: 'Hijo' },
        { id: 'E', name: 'Esposo' },
    ]
    const getDatosReniec = async (dni, tipo) => {
        let config = {
            method: 'get',
            url: `https://apiperu.net/api/dni/${dni}`,
            headers: {
                'Authorization': `Bearer ${ports.reniecApi}`,
            }
        };
        const rpta = await axios(config)
        if (rpta.data.success) {
            enqueueSnackbar('Encontrado con exito', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
            if (tipo === 'titular') {
                setNombres(rpta.data.data.nombres)
                setPaterno(rpta.data.data.apellido_paterno)
                setMaterno(rpta.data.data.apellido_materno)
            } else {
                setNombresTitular(rpta.data.data.nombres)
                setPaternoTitular(rpta.data.data.apellido_paterno)
                setMaternoTitular(rpta.data.data.apellido_materno)
            }

        } else {
            enqueueSnackbar('No se encontro el dni ingresado', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
        }
    }
    const handleBuscar = () => {
        if (tipodocumento === '01' && documento.length === 8) {
            getDatosReniec(documento, 'titular')
        } else {
            enqueueSnackbar('Solo se puede realizar la busqueda si el tipo documento es igual a DNI y la cantidad de numero de documento es igual a 8', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
        }
    }
    const handleBuscarTitular = () => {
        if (tipodocumentoTitular === '01' && documentoTitular.length === 8) {
            getDatosReniec(documentoTitular, 'NoTitular')
        } else {
            enqueueSnackbar('Solo se puede realizar la busqueda si el tipo documento es igual a DNI y la cantidad de numero de documento es igual a 8', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
        }
    }
    const handleGuardar = async () => {
        if (documento.length === 0) {
            enqueueSnackbar('Debe ingresar un Numero de documento', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
            return false
        }
        if (paterno.length === 0) {
            enqueueSnackbar('Debe ingresar un apellido paterno', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
            return false
        }
        if (materno.length === 0) {
            enqueueSnackbar('Debe ingresar un apellido materno', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
            return false
        }
        if (nombres.length === 0) {
            enqueueSnackbar('Debe ingresar un nombre', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
            return false
        }
        if (nacimiento.length === 0) {
            enqueueSnackbar('Debe ingresar una fecha de nacimiento', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
            return false
        }
        if (sexo.length === 0) {
            enqueueSnackbar('Debe ingresar un sexo', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
            return false
        }
        if (titular !== 'T') {
            if (paternoTitular.length === 0) {
                enqueueSnackbar('Debe ingresar un apellido paterno del titular', {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    TransitionComponent: Zoom,
                    autoHideDuration: 2000
                })
                return false
            }
            if (maternoTitular.length === 0) {
                enqueueSnackbar('Debe ingresar un apellido materno del titular', {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    TransitionComponent: Zoom,
                    autoHideDuration: 2000
                })
                return false
            }
            if (nombresTitular.length === 0) {
                enqueueSnackbar('Debe ingresar un nombre de titular', {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    TransitionComponent: Zoom,
                    autoHideDuration: 2000
                })
                return false
            }
        }
        const response = await axios.post(`https://apis.vesaliohce.com.pe/admision/registrarSistcomp`, {
            titular, tipodocumento, documento, paterno, materno, nombres, direccion, estadoCivil, sexo, nacimiento, paternoTitular, maternoTitular, nombresTitular, celular, correo
        })
        if (response.status === 200) {
            enqueueSnackbar('Correcto', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
        }else{
            enqueueSnackbar('Ocurrio un error al grabar los datos, verifique que todos los campos esten llenos, si persiste ingreselo por sistcomp', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000
            })
        }
        
        return false
    }

    return (
        <Box sx={{ p: 2 }}>
            <Grid container
                direction="row"
                justifyContent="center"
                alignItems="stretch"
                spacing={2}>
                <Grid item xs={3} lg={3}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Numero de documento</InputLabel>
                        <Select
                            value={tipodocumento}
                            label='Numero de documento'
                            onChange={(e) => setTipodocumento(e.target.value)}
                        >
                            {tipos.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={7} lg={7}>
                    <TextField
                        fullWidth
                        label='Nro Documento'
                        value={documento}
                        variant="outlined"
                        onChange={(e) => {
                            setDocumento(e.target.value)
                        }}
                    />
                </Grid>
                <Grid item xs={2} lg={2}>
                    <Button variant='contained' onClick={handleBuscar}>Buscar</Button>
                </Grid>
                <Grid item xs={6} lg={6}>
                    <TextField
                        fullWidth
                        label='Apellido Paterno'
                        value={paterno}
                        variant="outlined"
                        onChange={(e) => {
                            let numeros = '0123456789°!"#$%&/()=?¡*¨[]_:;><'
                            let inserta = true
                            numeros.split('').map((x) => {
                                if (e.target.value.includes(x)) {
                                    inserta = false
                                }
                                return false
                            })
                            if (inserta) {
                                setPaterno(e.target.value)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={6} lg={6}>
                    <TextField
                        fullWidth
                        label='Apellido Materno'
                        value={materno}
                        variant="outlined"
                        onChange={(e) => {
                            let numeros = '0123456789°!"#$%&/()=?¡*¨[]_:;><'
                            let inserta = true
                            numeros.split('').map((x) => {
                                if (e.target.value.includes(x)) {
                                    inserta = false
                                }
                                return false
                            })
                            if (inserta) {
                                setMaterno(e.target.value)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} lg={12}>
                    <TextField
                        fullWidth
                        label='Nombres'
                        value={nombres}
                        variant="outlined"
                        onChange={(e) => {
                            let numeros = '0123456789°!"#$%&/()=?¡*¨[]_:;><'
                            let inserta = true
                            numeros.split('').map((x) => {
                                if (e.target.value.includes(x)) {
                                    inserta = false
                                }
                                return false
                            })
                            if (inserta) {
                                setNombres(e.target.value)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} lg={12}>
                    <TextField
                        fullWidth
                        label='Dirección'
                        value={direccion}
                        variant="outlined"
                        onChange={(e) => {
                            setDireccion(e.target.value)
                        }}
                    />
                </Grid>
                <Grid item xs={4} lg={4}>
                    <FormControl fullWidth variant="outlined">
                        <TextField
                            fullWidth
                            value={nacimiento}
                            type={"date"}
                            variant="outlined"
                            onChange={(e) => {
                                setNacimiento(e.target.value)
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={4} lg={4}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Estado civil</InputLabel>
                        <Select
                            value={estadoCivil}
                            onChange={(e) => setEtadoCivil(e.target.value)}
                            label="Estado civil"
                        >
                            {
                                estadoCivilArray.map(x => <MenuItem value={x.Cod_EstaCivil}>{x.Des_EstaCivil}</MenuItem>)
                            }
                        </Select>
                    </FormControl>


                </Grid>
                <Grid item xs={4} lg={4}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Sexo</InputLabel>
                        <Select
                            value={sexo}
                            onChange={(e) => setSexo(e.target.value)}
                            label="Sexo"
                        >
                            {
                                genero.map(x => <MenuItem value={x.id}>{x.name}</MenuItem>)
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} lg={12}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Relacción con titular</InputLabel>
                        <Select
                            fullWidth
                            value={titular}
                            onChange={(e) => setTitular(e.target.value)}
                            label="Relacción con titular"
                        >
                            {
                                relacion.map(x => <MenuItem value={x.id}>{x.name}</MenuItem>)
                            }
                        </Select>
                    </FormControl>
                </Grid>
                {
                    titular !== 'T' && <>
                        <Grid item xs={12} lg={12}>
                            <Alert color='info' icon={false}>
                                <Card sx={{ p: 2 }} color="info">
                                    <Typography variant='h5'><b>Datos del titular</b></Typography>
                                    <Divider />

                                    <Grid container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="stretch"
                                        spacing={2}>
                                        <Grid item xs={3} lg={3}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel>Numero de documento</InputLabel>
                                                <Select
                                                    value={tipodocumentoTitular}
                                                    label='Numero de documento'
                                                    onChange={(e) => setTipodocumentoTitular(e.target.value)}
                                                >
                                                    {tipos.map((option) => (
                                                        <MenuItem key={option.id} value={option.id}>
                                                            {option.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={7} lg={7}>
                                            <TextField
                                                fullWidth
                                                label='Nro Documento'
                                                value={documentoTitular}
                                                variant="outlined"
                                                onChange={(e) => {
                                                    setDocumentoTitular(e.target.value)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={2} lg={2}>
                                            <Button variant='contained' onClick={handleBuscarTitular}>Buscar</Button>
                                        </Grid>
                                        <Grid item xs={6} lg={6}>
                                            <TextField
                                                fullWidth
                                                label='Apellido Paterno'
                                                value={paternoTitular}
                                                variant="outlined"
                                                onChange={(e) => {
                                                    let numeros = '0123456789°!"#$%&/()=?¡*¨[]_:;><'
                                                    let inserta = true
                                                    numeros.split('').map((x) => {
                                                        if (e.target.value.includes(x)) {
                                                            inserta = false
                                                        }
                                                        return false
                                                    })
                                                    if (inserta) {
                                                        setPaternoTitular(e.target.value)
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} lg={6}>
                                            <TextField
                                                fullWidth
                                                label='Apellido Materno'
                                                value={maternoTitular}
                                                variant="outlined"
                                                onChange={(e) => {
                                                    let numeros = '0123456789°!"#$%&/()=?¡*¨[]_:;><'
                                                    let inserta = true
                                                    numeros.split('').map((x) => {
                                                        if (e.target.value.includes(x)) {
                                                            inserta = false
                                                        }
                                                        return false
                                                    })
                                                    if (inserta) {
                                                        setMaternoTitular(e.target.value)
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={12}>
                                            <TextField
                                                fullWidth
                                                label='Nombres'
                                                value={nombresTitular}
                                                variant="outlined"
                                                onChange={(e) => {
                                                    let numeros = '0123456789°!"#$%&/()=?¡*¨[]_:;><'
                                                    let inserta = true
                                                    numeros.split('').map((x) => {
                                                        if (e.target.value.includes(x)) {
                                                            inserta = false
                                                        }
                                                        return false
                                                    })
                                                    if (inserta) {
                                                        setNombresTitular(e.target.value)
                                                    }
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Alert>

                        </Grid>
                    </>
                }
                <Grid item xs={8} lg={8}>
                    <TextField
                        fullWidth
                        label='Correo'
                        value={correo}
                        type="email"
                        variant="outlined"
                        onChange={(e) => {
                            setCorreo(e.target.value)
                        }}
                    />
                </Grid>
                <Grid item xs={4} lg={4}>
                    <TextField
                        fullWidth
                        label='Celular'
                        value={celular}
                        type={"tel"}
                        variant="outlined"
                        onChange={(e) => {
                            setCelular(e.target.value)
                        }}
                    />
                </Grid>
                <Grid item xs={12} lg={12}>
                    <Button variant='contained' fullWidth onClick={handleGuardar}>Registrar</Button>
                </Grid>
            </Grid>
        </Box>

    )
}
